import authModule from "../../../utilities/AuthModule";
import { SharepointContentTypeHelper } from "../components/helpers/sharepointContentTypeHelper";
import { ISharepointDocumentLibrary } from "../interfaces/ISharepointDocumentLibrary";
import { getSharePointContentTypes } from "./SharePointRestServices";

export class SharePointCompositeService {
  static getDocumentLibrariesWithContentTypes = async (documentLibraries: ISharepointDocumentLibrary[]) => {
    const token = await authModule.getSharePointAccessToken();
    return await Promise.all(
      documentLibraries.map(async library => ({
        contentTypes: SharepointContentTypeHelper.mapContentTypesToDropdownOptions(
          await getSharePointContentTypes(token, library.webUrl, library.sharePointListId)
        ),
        webUrl: library.webUrl,
        documentLibrary: library.documentLibrary,
        sharePointListId: library.sharePointListId
      }))
    );
  };
}
